import { H4, SubBody } from "@rikstv/shared-components";
import type { FC, ReactNode } from "react";
import { captureUXEvent } from "~/analytics/productAnalytics";
import Icon from "~/components/shared/icons/Icon";

import classNames from "classnames";
import classes from './FaqItem.module.css';

export const FaqItem: FC<{section: string, summary: string, details: string}> = ({section, summary, details}) => {
  const onClick: React.ToggleEventHandler<HTMLDetailsElement> = (e) => {
    if (e.currentTarget.open) {
      captureUXEvent('rtv_sales_internet_faq_expand', { section, summary });
    };
  }
  return (<DetailsSummary summary={<H4>{summary}</H4>} details={<SubBody>{details}</SubBody>} onClick={onClick} />)
};

export const DetailsSummary: FC<{ className?: string, summary: ReactNode, details: ReactNode, onClick?: React.ToggleEventHandler<HTMLDetailsElement>}> = ({summary, details, className, onClick}) => (
  <details className={classNames(classes.faqItem, className)} onToggle={onClick}>
      <summary>{summary}<Icon className={classes.chevron} type="chevron" /></summary>
      {details}
    </details>
)